import React, { useState } from "react";
import { CircularProgress, Drawer } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import '../Styles/Pages/InfoPage.css';
import ServerDetailsComponent from "../Components/Details/ServerDetailsComponent";
import SearchFilters from "../Components/Info/Components/SearchFilters";
import useServerData from "../Components/Info/Hooks/useServerData";
import { TABLE_COLUMNS } from "../Components/Info/Constants";

const InfoPage = () => {
  const { serverDetailsList, marketList, integrationTypeList, loading } = useServerData();
  const [selectedServer, setSelectedServer] = useState(null);
  const [search, setSearch] = useState("");
  const [market, setMarket] = useState("");
  const [integrationType, setIntegrationType] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleServerClick = (server) => {
    setSelectedServer(server);
    setDrawerOpen(true);
  };

  const filteredList = serverDetailsList.filter((server) => {
    const searchText = search.toLowerCase();
    return (
      (!market || server.CasinoSiteID?.toLowerCase() === market.toLowerCase()) &&
      (!integrationType ||
        server.IntegrationType?.toLowerCase() === integrationType.toLowerCase()) &&
      (searchText
        ? server.ServerName?.toLowerCase().includes(searchText) ||
        server.ServerID?.toLowerCase().includes(searchText)
        : true)
    );
  });

  const columns = React.useMemo(() => {
    return TABLE_COLUMNS.map(column => {
      if (column.field === 'details') {
        return {
          ...column,
          renderCell: (params) => (
            <button
              className="data-grid-button"
              onClick={() => handleServerClick(params.row)}
            >
              View Details
            </button>
          )
        };
      }
      return column;
    });
  }, []);

  return (
    <div className="info-page">
      <SearchFilters
        search={search}
        setSearch={setSearch}
        market={market}
        setMarket={setMarket}
        integrationType={integrationType}
        setIntegrationType={setIntegrationType}
        marketList={marketList}
        integrationTypeList={integrationTypeList}
      />

      <div className="table-container">
        {loading ? (
          <CircularProgress />
        ) : (
          <div style={{ height: 600, width: '100%', overflow: 'auto' }}>
            <DataGrid
              rows={filteredList.map((row) => ({ ...row, id: row.ID }))}
              columns={columns}
              pageSize={10}
              autoHeight={false}
              disableColumnMenu
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  position: 'sticky',
                  top: 0,
                  backgroundColor: 'var(--navmenu-primary)',
                  color: 'var(--text-navbar)',
                  zIndex: 1,
                  fontWeight: 'bold',
                  borderBottom: '2px solid var(--accent-color)',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: '1px solid var(--border-color)',
                },
              }}
            />
          </div>
        )}
      </div>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: '50%',
            backgroundColor: 'var(--background-primary)',
          },
        }}
      >
        {selectedServer && <ServerDetailsComponent serverDetails={selectedServer} />}
      </Drawer>
    </div>
  );
};

export default InfoPage;